import React from "react";

export default function Image({ id, src, alt, width, height, draggable, onLoad }) {
    return (
        <img id={id} src={src} alt={alt} width={width} height={height} draggable={draggable} onLoad={onLoad} />
    )
}
